<template>
  <div>
    <div v-if="!notEmptyObject(tax_mileage)" id="no_mileage" class="d-flex align-items-center">
      <div class="container text-center">
        <h4 class="font-weight-bold">NO MILEAGE RECORDED BY WORKER</h4>
      </div>
    </div>
    <div v-else class="mileage_datatable">
      <datatable :type="'mileage'" :recordType="'worker'" :rowData="tax_mileage" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "datatables/datatable";

export default {
  name: "mileage",
  components: {Datatable},
  props: ['tax_mileage', 'tax_mileage_loaded'],
  data() {
    return {
      loadingMessage: 'Loading Worker Mileage...',
      noRowsMessage: 'No Worker Mileage Found',
      columns: [
        {headerName: 'Mileage Added', minWidth: 100, valueGetter: this.mileage_added_value_getter},
        {headerName: 'Date Mileage For', minWidth: 100, valueGetter: this.mileage_for},
        {headerName: 'From', field: 'mileage_from', minWidth: 100},
        {headerName: 'To', field: 'mileage_to', minWidth: 100},
        {headerName: 'Mileage (Miles)', field: 'mileage_quantity', minWidth: 100},
      ]
    }
  },
  methods: {
    mileage_added_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    mileage_for(params) {
      return this.$options.filters.formatDate(params.data.mileage_date);
    }
  }
}
</script>

<style scoped lang="scss">
#no_mileage {
  min-height: calc(100vh - 200px) !important;
}

.mileage_datatable {
  .full_height_datatable {
    height: calc(100vh - 185px);
  }
}
</style>
